// Updated AboutSection.jsx
import React from 'react';
import { Helmet } from 'react-helmet';
import '../styles/AboutSection.css';

function AboutSection() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  const features = [
    {
      icon: "/media/icons/professional-icon.png",
      title: "Certified Professional",
      description: "NASM certified with advanced specializations in strength training and nutrition"
    },
    {
      icon: "/media/icons/success-icon.png",
      title: "200+ Success Stories",
      description: "Proven track record of helping clients achieve lasting fitness transformations"
    },
    {
      icon: "/media/icons/personalized-icon.png",
      title: "Personalized Approach",
      description: "Every program is tailored to your unique goals, fitness level, and lifestyle"
    },
    {
      icon: "/media/icons/wellness-icon.png",
      title: "Holistic Wellness",
      description: "Focus on physical fitness, mental health, and sustainable lifestyle changes"
    }
  ];

  return (
    <section id="about-us" className="about-section" aria-labelledby="about-heading" itemScope itemType="https://schema.org/Organization">
      <Helmet>
        <title>About Lu - Fit | Certified Personal Trainer in Cape Town</title>
        <meta
          name="description"
          content="Learn more about Lu - Fit — Cape Town’s trusted personal training and fitness coaching service. See our story, values, and expert team."
        />
      </Helmet>

      <div className="about-container">
        <div className="about-grid">
          {/* Text Content */}
          <div className="about-content">
            <div className="about-badge">About Your Trainer</div>

            <h2 id="about-heading" className="about-heading">
              Meet Lu
              <span className="highlight">Your Fitness Partner</span>
            </h2>

            <p className="about-paragraph">
              With years of experience in personal training and a passion for helping people unlock their
              potential, Lu is dedicated to making fitness accessible, enjoyable, and sustainable for everyone.
            </p>

            <p className="about-paragraph">
              His approach combines science-based training methods with personalized attention to ensure
              clients not only reach their goals but maintain them for life. Whether you're just starting
              your fitness journey or looking to break through plateaus, Lu is here to guide you every step of the way.
            </p>

            <button onClick={scrollToContact} className="cta-button">
              Work With Me
            </button>
          </div>

          {/* Features */}
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card" style={{ animationDelay: `${index * 100}ms` }}>
                <img className="feature-icon"  src={feature.icon}/>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Credentials */}
        <div className="credentials">
          <h3 className="credentials-heading">Certifications & Credentials</h3>
          <div className="credentials-grid">
            {[
              ["NASM-CPT", "Certified Personal Trainer"],
              ["NASM-CES", "Corrective Exercise Specialist"],
              ["PN1", "Precision Nutrition Level 1"],
              ["CPR/AED", "Current Certification"]
            ].map(([title, subtitle], idx) => (
              <div key={idx} className="credential-card">
                <div className="credential-title">{title}</div>
                <div className="credential-subtitle">{subtitle}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
